<template>
  <div>
    <div class="maxbox">
      <div>
        <div class="top">
          <p>我的矿机</p>
        </div>
        <div class="main">
          <button class="return" @click="goback">
            <img src="@/assets/images/left-arrow.png" alt="" />
          </button><br>

          <div id="referrals" class="referrals-container">
            <div
              v-for="(machine, index) in validMachines"
              :key="index"
              class="pyuser"
            >
              <img src="@/assets/images/kj2.png" alt="" />
              <div class="info-box">
                <p class="machine-text">{{ getMachineName(machine.type) }}</p>
                <p class="count-text">矿机数量：{{ machine.count }} 台</p>
              </div>
              <div class="right-box">
                <p class="remain-text">剩余次数：{{ machine.remainingDays }}</p>
                <p class="earned-text">
                  已赚：{{ formatAmount(machine.batchEarn) }}
                </p>
              </div>
            </div>

            <div v-if="validMachines.length === 0" class="pyuser">
              <img src="@/assets/images/kj2.png" alt="" />
              <p class="address">暂无矿机</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ethers } from "ethers";
import { contractAddress, contractABI } from '@/js/contract.js';
export default {
  name: "remainCount",
  data() {
    return {
      myMachines: [],
    };
  },
  computed: {
    validMachines() {
      return this.myMachines.filter(item => {
        const remaining = parseInt(item.remainingDays) || 0;
        return remaining > 0;
      });
    }
  },
  methods: {
    goback() {
      this.$router.go(-1);
    },
    async connectWallet() {
      if (window.ethereum) {
        try {
          await window.ethereum.request({ method: "eth_requestAccounts" });
          return new ethers.providers.Web3Provider(window.ethereum);
        } catch (error) {
          console.error("用户拒绝了账户访问请求", error);
        }
      } else {
        console.error("未检测到Ethereum提供商。请安装MetaMask。");
      }
    },

    async fetchMyMachines() {
      const provider = await this.connectWallet();
      if (!provider) return;
      const signer = provider.getSigner();
      const contract = new ethers.Contract(contractAddress, contractABI, signer);

      try {
        const res = await contract.getMyMachineInvestments();
        console.log("矿机数据:", res);

        let list = [];
        for (let i = 0; i < res[0].length; i++) {
          list.push({
            type: res[0][i].toString(),
            count: res[1][i].toString(),
            remainingDays: res[2][i].toString(),
            batchEarn: res[4][i].toString()
          });
        }
        this.myMachines = list;
      } catch (err) {
        console.error("获取矿机失败", err);
      }
    },

    formatAmount(amount) {
      if (!amount || amount === "0") return "0";
      return ethers.utils.formatUnits(amount, 6);
    },

    getMachineName(type) {
      if (type === "0") return "TND矿机 1型";
      if (type === "1") return "TND矿机 2型";
      if (type === "2") return "TND矿机 3型";
      return "未知矿机";
    },

    async fetchData() {
      const provider = await this.connectWallet();
      if (!provider) return;
      await this.fetchMyMachines();
    },
  },
  mounted() {
    this.fetchData();
  },
};
</script>

<style scoped>
@import "@/assets/css/team.css";
@import "@/assets/css/style.css";

.main {
  padding-top: 50px;
}

.referrals-container {
  max-height: 750px;
  overflow-y: auto;
}

.pyuser {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 10px;
}

.info-box {
  flex: 1;
}

.right-box {
  margin-left: auto;
  text-align: right;
}

.machine-text {
  font-size: 14px;
  color: #333;
  margin: 0;
}

.count-text {
  font-size: 12px;
  color: #333;
  margin: 2px 0 0 0;
}

.remain-text {
  font-size: 12px;
  color: #2f7dff;
  margin: 0;
}

.earned-text {
  font-size: 12px;
  color: #ff6b35;
  margin: 2px 0 0 0;
  font-weight: bold;
}

.address {
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
}
</style>